var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpercutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.543 48.5V24.2304C25.543 11.2865 35.7169 0.5 48.4997 0.5V24.7697C48.4997 37.7135 38.3257 48.5 25.543 48.5Z",
    fill: "#4239B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4567 48.4965V35.283C23.4567 22.0696 13.0218 11.5527 0.5 11.5527V24.7662C0.5 37.71 10.674 48.4965 23.4567 48.4965Z",
    fill: "#4239B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpercutLogo);
export default __webpack_public_path__ + "static/media/upercut-logo.f504a3d3845f69eef8af5606df2b3155.svg";
export { ForwardRef as ReactComponent };